module.exports = __webpack_public_path__ + "static/media/adolescente.dae15847.png";